import React from "react";
import PropTypes from "prop-types";
import {Button, Card} from "antd";
import {AppstoreIcon, PlayIcon} from '@web/assets/icons';
import {useDispatch} from 'react-redux';
import appActions from "@web/redux/app/actions";
import AppInstallButton from './AppInstallButton';
import UserAvatar from './UserAvatar';
import Icon from './Icon';

AppListingCard.propTypes = {
  path: PropTypes.string,
  app: PropTypes.object,
  collapsed: PropTypes.bool,
  className: PropTypes.string,
  selected: PropTypes.bool,
};

function AppListingCard(props) {
  const dispatch = useDispatch();

  const onClick = () => {
    if (props.onSelect) {
      props.onSelect(props.path, props.app);
      return;
    }

    dispatch(appActions.setActiveDetail({path: props.path, app: props.app}, true));
  }

  return <Card
    bordered={!!props.selected}
    onClick={onClick}
    extra={
      !!props.selected &&
      <AppInstallButton listingPath={props.path} />}
    className={`card-rounded card-no-separator card-simple extra-round card-highlight ${props.className} card-body-scroll`}
    title={
      <div className="icon-btn">
        {props.app?.logo ?
          <UserAvatar photoURL={props.app?.logo} /> :
          <UserAvatar
            icon={
              props.app?.icon ?
                <Icon name={props.app?.icon} /> :
                <AppstoreIcon />
            }
          />
        }
        <h6 className="font-lg bolded capitalize">{props.app.appName}</h6>
        {/*<span className="font-lg bolded">{props.app.title}</span>*/}
      </div>
    }
  >
    <div className="space space-col">
      <span className="font-lg bolded">{props.app.title}</span>
      <span className="muted font-lg">{props.app.description}</span>
      {props.app.userId && <div className="w-full" style={{marginTop: 12}}>
        <Button size="large" shape="round" className="icon-btn orange-color"><PlayIcon /> Run App</Button>
      </div>}
    </div>
  </Card>
}

export default AppListingCard;
